import logo from '../logo.png';

import { useState, useEffect } from 'react';
//import { useLocation } from 'react-router-dom';
import { Radikle } from '../Components/Radikle';

import { useContext } from 'react';
import { AppContext } from '../Contexts/AppContextProvider.jsx';

import { useNavigate } from "react-router-dom";

import React from 'react';

export function Home() {

  const [username, setUsername] = useState('');

    var userIP = {};
    var browserInfo = {};
    var ipinfo = {};
    var userAgent = {};
    var screenSize = {};
    var deviceInfo = {};
    var lat = {}, lon = {};
    var ipgeolocation = {};

    //let location = useLocation();
    //console.log('LOCATION STATE: '+JSON.stringify(location.state));

    const applnContext = useContext(AppContext);
    
    const navigate = useNavigate();

    //const setMasterData = (data) => {callback(data)};

    let [validEmail, setValidEmail] = useState('');

     // Function to gather user information
     const gatherUserInfo = (e) => {
        // User's IP address (may not be accurate in all cases)
        userIP = fetch('https://api64.ipify.org?format=json')
            .then(response => response.json())
            .then(data => {console.log('User IP Information from ipify:', data);})
            .catch(error => console.error('Error fetching IP:', error));
    
          // User's browser information
          browserInfo = {
              userAgent: navigator.userAgent,
              language: navigator.language,
              platform: navigator.platform,
              geolocation: navigator.geolocation,
              cookiesEnabled: navigator.cookieEnabled
          };
      
          // Display the gathered information
          Promise.all([userIP, browserInfo])
              .then(([ip, browser]) => {
                  console.log('User IP:', ip);
                  console.log('Browser Information:', browser);
              });
          }

           // Function to fetch user IP information
  function fetchUserIPInfo() {
    // Using the IPinfo.io API
    const apiUrl = 'https://ipinfo.io/json';

    // Make a request to the IPinfo.io API
    fetch(apiUrl)
        .then(response => response.json())
        .then(data => {
          ipinfo = data;
          console.log('User IP Information:', data);
        })
        .catch(error => console.error('Error fetching IP information:', error));
  }

  // Function to gather user device information
  function gatherDeviceInfo() {
    // User agent information
    userAgent = navigator.userAgent;

    // Screen information
    screenSize = {
      width: window.screen.width,
      height: window.screen.height,
      pixelRatio: window.devicePixelRatio
    };

    // Other device-related information
    deviceInfo = {
      language: navigator.language,
      platform: navigator.hardwareConcurrencyplatform,
      
      cookiesEnabled: navigator.cookieEnabled,
      concurrency: navigator.hardwareConcurrency,
      online: navigator.onLine
    };

    // Display the gathered information
    console.log('User Agent:', userAgent);
    console.log('Screen Information:', screenSize);
    console.log('Device Information:', deviceInfo);
  }

  // Function to fetch user geolocation
  function fetchUserLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
          // Success callback
          (position) => {
            const { latitude, longitude } = position.coords;
            lat = latitude;
            lon = longitude;
            console.log('Latitude:', latitude);
            console.log('Longitude:', longitude);
          },
          // Error callback
          (error) => {
            console.error('Error getting location:', error.message);
          }
      );
    } else {
      console.error('Geolocation is not supported in this browser.');
    }
  }

  function fetchUserIPGeolocation() {
    // Using the ipinfo.io API
    const apiUrl = 'https://ipinfo.io/json';

    // Make a request to the ipinfo.io API
    fetch(apiUrl)
        .then(response => response.json())
        .then(data => {
          ipgeolocation = data;
          console.log('User IP Geolocation:', data);
        })
        .catch(error => console.error('Error fetching IP geolocation:', error));
  }

  function getAndStoreClientData() {
    if(sessionStorage.getItem("ClientData") != null) {
      console.log("Client Data are already available in session");
      return;
    }

    gatherUserInfo();
    fetchUserIPInfo();
    gatherDeviceInfo();
    fetchUserLocation();
    fetchUserIPGeolocation();

    let data = {
      'userIP': userIP,
      'browserInfo': browserInfo,
      'ipinfo': ipinfo,
      'userAgent': userAgent,
      'screenSize': screenSize,
      'deviceInfo': deviceInfo,
      'lat': lat,
      'lon' : lon,
      'ipgeolocation': ipgeolocation
    };
    sessionStorage.setItem("ClientData", data);
    console.log("Compiled data ALL: "+JSON.stringify(data));

    window.myGlobalVariable.appState.data = data;

    console.log("Applicatoin Context: " +JSON.stringify(applnContext));
    console.log("Applicatoin Context Client State: " +JSON.stringify(applnContext.clientState));
    applnContext.setClientState(data);
    console.log("Before waiting to print client data");
    printClientData();
  }
  
  async function printClientData() {
    setTimeout(() => {
      console.log("After waiting to print client data");
      console.log("Applicatoin Context after update: " +JSON.stringify(applnContext));
    }, 12000);
  }

  // RSA Key Pair - ***********************************************************************
  // Parameters for RSA key generation
  const rsaParams = {
    name: "RSA-OAEP",
    modulusLength: 2048,          // Length of the key (e.g., 2048 bits)
    publicExponent: new Uint8Array([1, 0, 1]), // Common value: 65537
    hash: "SHA-256",               // Hash function to use
  };

  // Generate RSA key pair
  async function generateRSAKeyPair() {
    if(sessionStorage.getItem("RSAPublicKey") != null &&
       sessionStorage.getItem("RSAPrivateKey") != null) {
        console.log("RSA Key Pair are already available in Session");
        return;
    }

    try {
      const keyPair = await window.crypto.subtle.generateKey(
        rsaParams,
        true,          // Extractable key: can be exported if true
        ["encrypt", "decrypt"] // Usages for the key
      );

      // Export public key in a usable format (e.g., PEM)
      const publicKey = await window.crypto.subtle.exportKey("spki", keyPair.publicKey);
      const privateKey = await window.crypto.subtle.exportKey("pkcs8", keyPair.privateKey);

      sessionStorage.setItem("RSAPublicKey", publicKey);
      sessionStorage.setItem("RSAPrivateKey", privateKey);
      console.log("Public Key:", arrayBufferToBase64(publicKey));
      console.log("Private Key:", arrayBufferToBase64(privateKey));
    } catch (err) {
      console.error("Error generating key pair:", err);
    }
  }

  // Helper function to convert ArrayBuffer to Base64
  function arrayBufferToBase64(buffer) {
    const binary = String.fromCharCode(...new Uint8Array(buffer));
    return btoa(binary);
  }

  // Crypto Key Generation **************************************************************
  function generateCryptoKeys() {
    if(sessionStorage.getItem("RSA-OAEP-Keys") != null) {
      console.log('Crypto Keys are already available in Session');
      return;
    }

    console.log('Generating Crypto Keys');
    window.crypto.subtle.generateKey(
      {
        name: "RSA-OAEP",
        modulusLength: 4096,
        publicExponent: new Uint8Array([1, 0, 1]),
        hash: "SHA-256"
      },
      true,
      ["encrypt", "decrypt"]
    ).then(handleFulfilledA, handleRejectedA);
    
  }

  function handleFulfilledA(result) {
    sessionStorage.setItem("RSA-OAEP-Keys", result);
    console.log('RSA-OAEP Key Pair generation result: '+JSON.stringify(result));
  }

  function handleRejectedA(reason) {
    console.log('RSA-OAEP Key Pair generation failure reason: '+JSON.stringify(reason));
  }
    
  // PKCE ********************************************************************************
  async function pkce() {
    if(sessionStorage.getItem("pkce_code_verifier") != null &&
       sessionStorage.getItem("pkce_code_chellenge") != null) {
        console.log("PKCE is already available in Session");
        return;
    }

    // Initialize PKCE parameters
    const codeVerifier = generateCodeVerifier();
    const codeChallenge = await generateCodeChallenge(codeVerifier);
    sessionStorage.setItem("pkce_code_verifier", codeVerifier);
    sessionStorage.setItem("pkce_code_chellenge", codeChallenge);
    console.log('PKCE Code Verifier: ' + codeVerifier);
    console.log('PKCE Code Challenge: ' + codeChallenge);
  }

  // Generate a random string to use as the code verifier
  function generateCodeVerifier() {
    const array = new Uint32Array(56);
    window.crypto.getRandomValues(array);
    return Array.from(array, dec => ("0" + dec.toString(16)).substr(-2)).join('');
  }

  // Base64 URL encode (RFC 4648)
  function base64UrlEncode(arrayBuffer) {
    return btoa(String.fromCharCode.apply(null, new Uint8Array(arrayBuffer)))
      .replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }

  // Generate a code challenge from the code verifier
  async function generateCodeChallenge(codeVerifier) {
    const encoder = new TextEncoder();
    const data = encoder.encode(codeVerifier);
    const digest = await window.crypto.subtle.digest('SHA-256', data);
    return base64UrlEncode(digest);
  }

  // Use Effect *****************************************************************************
  useEffect(() => {
    console.log('On useEffect - Home');
    navigate("/login");

  }, []);   // Empty Dependency Array - 
            // Executed only once when the page launches but not on every re-render
            
  // HTML Content *************************************************************************
  return (
      <div>
          <img src={logo} className="App-logo" alt="logo" />
          <Radikle></Radikle>
          <div>
          IAAM {username}
          </div>
      </div>
  )
}
